import { Component, OnInit } from '@angular/core';
import { AccountService, AlertService } from './_services';
import { DocumentsRefNoDialog, InputRefNoDialog } from '@app/_components/home/home.component';
import { MsalService, MsalBroadcastService, MsalGuardConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalValues } from '@app/_services/global-values';
import { RestService } from '@app/_services/rest.service';
import { Employee } from './_models/employee';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Proplab Portal';
  isIframe = false;
  isMk3ManagementGroup = false;
  isMk3ITGroup = false;
  inputDialogRef!: MatDialogRef<InputRefNoDialog>;
  documentsDialogRef!: MatDialogRef<DocumentsRefNoDialog>;

  constructor(
    private restService: RestService, public accountService: AccountService, public dialog: MatDialog, private router: Router, private alertService: AlertService, private msalService: MsalService, public global: GlobalValues, 
  ) { }

  async ngOnInit() {
    const pca = this.msalService.instance as PublicClientApplication;
    await pca.initialize();
    this.isIframe = window !== window.parent && !window.opener;
    this.accountService.startup();

    await this.global.loadUserRoles();
    this.isIframe = window !== window.parent && !window.opener;
    this.isMk3ITGroup = this.global.isMk3ITGroup;
    this.isMk3ManagementGroup = this.global.isMk3ManagementGroup;
  }

  public async openDocumentsSearchDialog() {
    this.documentsDialogRef = this.dialog.open(DocumentsRefNoDialog, {
      minWidth: '400px',
      maxWidth: '1000px'
    });
  }

  public async openSearchDialog(isByRefNo: boolean) {
    this.inputDialogRef = this.dialog.open(InputRefNoDialog, {
      minWidth: '400px',
      maxWidth: '1000px',
      data: { isByRefNo: isByRefNo }
    });

    /*this.inputDialogRef.afterClosed().subscribe(result => {
      //console.log('result = ' + result);
      if (result == '' || result == undefined) {
        this.inputDialogRef.close('');
        this.alertService.error('Invalid Claim. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk');
      }
      else
        this.router.navigate(['./case-details/' + result]);
    },
      error => {
        console.log('error = ' + error);
        alert(error);
      }
    )*/
  }
}
